export default __webpack_public_path__ + "static/media/banner-carroussel.1507bd20.svg";